import { base } from './';
import { AdditionUpdateType } from 'types';

const PATH = '/event-additional';

const get = (id: string) => base.get(`${PATH}/${id}`);

const post = ({ id, ...data }: AdditionUpdateType) =>
  base.post(`${PATH}/${id}`, data);

const patch = ({ id, ...data }: AdditionUpdateType) =>
  base.patch(`${PATH}/${id}`, data);

export { get, post, patch };
